/**
 * @flow
 * @relayHash c20a7b5eccd12e080db2a87df6ccecfd
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AddShipmentItemInput = {|
  shipmentId: string,
  itemId: string,
  quantity: number,
  description?: ?string,
|};
export type AddShipmentItemMutationVariables = {|
  input: AddShipmentItemInput
|};
export type AddShipmentItemMutationResponse = {|
  +addShipmentItem: {|
    +shipmentItemEdge: {|
      +node: {|
        +id: string,
        +quantity: number,
        +description: ?string,
        +pickedQuantity: number,
        +fullyPicked: boolean,
        +item: {|
          +id: string,
          +name: string,
          +itemNumber: string,
          +lotTracking: ?boolean,
          +quantityUOM: {|
            +id: string,
            +symbol: string,
          |},
        |},
        +serials: ?$ReadOnlyArray<?{|
          +id: string,
          +serialNumber: string,
        |}>,
        +picks: ?$ReadOnlyArray<?{|
          +id: string,
          +quantity: number,
          +pickedAt: ?any,
          +lot: ?{|
            +id: string,
            +lotNumber: string,
          |},
        |}>,
        +createdAt: any,
      |}
    |}
  |}
|};
export type AddShipmentItemMutation = {|
  variables: AddShipmentItemMutationVariables,
  response: AddShipmentItemMutationResponse,
|};
*/


/*
mutation AddShipmentItemMutation(
  $input: AddShipmentItemInput!
) {
  addShipmentItem(input: $input) {
    shipmentItemEdge {
      node {
        id
        quantity
        description
        pickedQuantity
        fullyPicked
        item {
          id
          name
          itemNumber
          lotTracking
          quantityUOM {
            id
            symbol
          }
        }
        serials {
          id
          serialNumber
        }
        picks {
          id
          quantity
          pickedAt
          lot {
            id
            lotNumber
          }
        }
        createdAt
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "AddShipmentItemInput!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "quantity",
  "args": null,
  "storageKey": null
},
v3 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "addShipmentItem",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AddShipmentItemPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "shipmentItemEdge",
        "storageKey": null,
        "args": null,
        "concreteType": "ShipmentItemEdge",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "ShipmentItem",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "description",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "pickedQuantity",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "fullyPicked",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "item",
                "storageKey": null,
                "args": null,
                "concreteType": "Item",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "name",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "itemNumber",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "lotTracking",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "quantityUOM",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UOM",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "symbol",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "serials",
                "storageKey": null,
                "args": null,
                "concreteType": "ItemSerial",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "serialNumber",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "picks",
                "storageKey": null,
                "args": null,
                "concreteType": "ShipmentPick",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  (v2/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "pickedAt",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "lot",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Lot",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "lotNumber",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "createdAt",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "AddShipmentItemMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v3/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "AddShipmentItemMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v3/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "AddShipmentItemMutation",
    "id": null,
    "text": "mutation AddShipmentItemMutation(\n  $input: AddShipmentItemInput!\n) {\n  addShipmentItem(input: $input) {\n    shipmentItemEdge {\n      node {\n        id\n        quantity\n        description\n        pickedQuantity\n        fullyPicked\n        item {\n          id\n          name\n          itemNumber\n          lotTracking\n          quantityUOM {\n            id\n            symbol\n          }\n        }\n        serials {\n          id\n          serialNumber\n        }\n        picks {\n          id\n          quantity\n          pickedAt\n          lot {\n            id\n            lotNumber\n          }\n        }\n        createdAt\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'dafbb005ea14ce5dc495e3d9d126d5d0';
module.exports = node;
